const questionInfo = {
    grade: 7,
    type: [
        {
            index: 0,
            name: '조망',
        }, {
            index: 1,
            name: '갈등',
        }, {
            index: 2,
            name: '불안/회피',
        }
    ],
    questions: [[
        {
            order: 1,
            name: 'future-1',
            question: '나는 연인의 말을 경청할 뿐만 아니라, 연인이 말하는 것의 의미를 이해하고 왜 그런 말을 하는지 아는 것 같다.',
            direction: true,
            value: undefined,
        }, {
            order: 2,
            name: 'future-2',
            question: '나는 연인이 나와의 관계나 경험에서 어떻게 느끼고 있는지 잘 알고 있다.',
            direction: true,
            value: undefined,
        }, {
            order: 3,
            name: 'future-3',
            question: '나는 연인이 다투었을 때 잠시 연인의 입장이 되어보려고 한다.',
            direction: true,
            value: undefined,
        }, {
            order: 4,
            name: 'future-4',
            question: '나는 일반적으로 연인이 내게 이야기하는 것들을 충분히 이해하지 못하는 편이다.',
            direction: false,
            value: undefined,
        }, {
            order: 5,
            name: 'future-5',
            question: '나는 연인이 말하는 걸 어려워하더라도 일반적으로 연인이 의미하는 것을 이해한다.',
            direction: true,
            value: undefined,
        }, {
            order: 6,
            name: 'future-6',
            question: '연인이 자신의 삶에서 경험하는 것들을 어떻게 느끼고 있는지 정확하게 이해할 수 있다.',
            direction: true,
            value: undefined,
        }
    ], [
        {
            order: 1,
            name: 'conflict-1',
            question: '시간을 갖는게 상책이라고 생각하고, 감정이 가라앉을 때 까지는 일단 소통을 미룬다.',
            direction: false,
            value: undefined,
        }, {
            order: 2,
            name: 'conflict-2',
            question: '연인에게 서운함을 토로하거나 짜증을 부린다.',
            direction: false,
            value: undefined,
        }, {
            order: 3,
            name: 'conflict-3',
            question: '연인과 갈등을 피하기 위해 최대한 맞춰주려 한다.',
            direction: false,
            value: undefined,
        }, {
            order: 4,
            name: 'conflict-4',
            question: '나의 잘못된 점을 인정하고 먼저 사과한다.',
            direction: true,
            value: undefined,
        }, {
            order: 5,
            name: 'conflict-5',
            question: '나는 우리 관계에서 발생하는 문제를 처리하는데 종종 무력감과 불안을 느낀다.',
            direction: false,
            value: undefined,
        }, {
            order: 6,
            name: 'conflict-6',
            question: '나는 우리 사이에 발생하는 문제들에 대해 때로는 얘기하지 않는 것 같다.',
            direction: false,
            value: undefined,
        }, {
            order: 7,
            name: 'conflict-7',
            question: '연인을 이해하기 위해 질문하고 공감을 먼저 해준다.',
            direction: true,
            value: undefined,
        }
    ], [
        {
            order: 1,
            name: 'attachmentType-1',
            question: '나는 연인과의 관계가 밀착되기를 기대한다.',
            direction: false,
            type: 1,
            value: undefined,
        }, {
            order: 2,
            name: 'attachmentType-2',
            question: '내가 맺는 관계들에 대해 걱정을 많이 한다.',
            direction: true,
            type: 0,
            value: undefined,
        }, {
            order: 3,
            name: 'attachmentType-3',
            question: '연인이 내게 지나치게 가까워지려고 하면 불편하다.',
            direction: true,
            type: 1,
            value: undefined,
        }, {
            order: 4,
            name: 'attachmentType-4',
            question: '내가 연인에게 관심을 갖는 것만큼 그 사람이 내게 관심이 없을까봐 걱정한다.',
            direction: true,
            type: 0,
            value: undefined,
        }, {
            order: 5,
            name: 'attachmentType-5',
            question: '마음은 연인과 가까워지고 싶은데 실제로는 늘 주저하게 된다.',
            direction: true,
            type: 1,
            value: undefined,
        }, {
            order: 6,
            name: 'attachmentType-6',
            question: '연인에게 좀 더 감정을 표현하고 우리 관계에 대해 책임감을 보여달라고 요구한다.',
            direction: true,
            type: 0,
            value: undefined,
        }, {
            order: 7,
            name: 'attachmentType-7',
            question: '나는 때로 사적인 생각과 감정을 연인과 나누고 싶지 않을 때가 있다.',
            direction: true,
            type: 1,
            value: undefined,
        }, {
            order: 8,
            name: 'attachmentType-8',
            question: '나는 종종 버림받는 것에 대한 두려움을 느낀다.',
            direction: true,
            type: 0,
            value: undefined,
        }, {
            order: 9,
            name: 'attachmentType-9',
            question: '나는 연인에게 의지하는 것이 어렵다.',
            direction: true,
            type: 1,
            value: undefined,
        }, {
            order: 10,
            name: 'attachmentType-10',
            question: '나의 연인은 내가 원하는 만큼 나와 가까워지고 싶어하지 않는다는 생각이 든다.',
            direction: true,
            type: 0,
            value: undefined,
        }, {
            order: 11,
            name: 'attachmentType-11',
            question: '내가 경험하는 어려움은 연인에게 의지하기보다 스스로 해결해야 한다고 생각한다.',
            direction: true,
            type: 1,
            value: undefined,
        }, {
            order: 12,
            name: 'attachmentType-12',
            question: '연인이 내가 원하는 만큼 내 옆에 있어주지 않으면 좌절감을 느낀다.',
            direction: true,
            type: 0,
            value: undefined,
        }
    ]],
};

export default questionInfo;
